module.exports = __webpack_public_path__ + "static/media/silhouette4x.f521d2b0.png";